import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdLockReset } from "react-icons/md";
import { useSnackbar } from "../../../context/SnackBarContext";
import fetcher from "../../../helper/fetcher";
import ResetPasswordConfirmQr from "./ResetPasswordConfirmQr";
import ResetPasswordChangedQr from "./ResetPasswordChangedQr";
import ResetPasswordOtpQr from "./ResetPasswordOtpQr";

export default function ResetPasswordEmailQr() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
    const { showSuccess, showError } = useSnackbar();

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    if (!email) {
      showError("Please enter your email");
      return;
    }

    fetcher
      .post("/qr/auth/forgot_password", { email })
      .then((res) => {
        if (res.data.success) {
          showSuccess(res.data.message || "Reset email sent!");
          setStep(2);
        } else {
          showError(res.data.message || "Something went wrong");
        }
      })
      .catch((err) => {
        showError(err.response?.data?.message || "Server error");
      })
      .finally(() => {
        console.log("Reset password request finished");
      });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f4f5f7]">
      <div className="w-full max-w-md px-6 py-10 border border-gray-200 shadow-lg bg-white">
        {step === 1 && (
          <>
            <div className="flex justify-center mb-6">
              <MdLockReset className="w-20 h-20 text-[#bf98ce]" />
            </div>

            <h1 className="text-2xl font-semibold text-center text-gray-900">
              Reset your password
            </h1>
            <p className="text-center text-gray-500 text-sm mt-2">
              Enter your email so that we can send you a password reset link
            </p>

            <form onSubmit={handleEmailSubmit} className="mt-6">
              <label className="block text-black font-semibold uppercase text-sm mb-2">
                Email
              </label>
              <input
                type="email"
                placeholder="e.g. username@kenaty.com"
                className="w-full p-2 border border-gray-300 rounded"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <button
                type="submit"
                className="w-full mt-6 bg-[#bf98ce] text-white font-semibold py-2 rounded transition cursor-pointer"
              >
                Send Email
              </button>
            </form>
          </>
        )}

        {step === 1 && (
          <div className="mt-6 text-center">
            <button
              onClick={() => navigate("/contact-card/login")}
              className="text-gray-700 text-sm flex items-center justify-center gap-2 hover:underline cursor-pointer "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
              Back to Login
            </button>
          </div>
        )}

        {step === 2 && <ResetPasswordOtpQr email={email} onNext={() => setStep(3)} />}
        {step === 3 && <ResetPasswordConfirmQr email={email} onNext={() => setStep(4)} />}
        {step === 4 && <ResetPasswordChangedQr />}
      </div>
    </div>
  );
}
